<template>
  <div style="min-height: 100vh;">
    <div class="entry-list">
      <div class="teams"  v-if="list.length > 0">
        <div class="team" v-for="(item, index) in list" :key="index">
          <div class="top" @click="goMatchDetail(item)">
            <div class="left">
              <div class="status-team-name">
                <span class="status _0" v-if="item.auditStatus === 0 || item.auditStatus === 1">待确认</span>
                <span class="status _1" v-else-if="item.auditStatus === 3">锁 定</span>
                <span class="status _2" v-else-if="item.auditStatus === 2">确 认</span>
                <span class="status _3" v-else-if="item.auditStatus === -1">退 回</span>
                <span class="team-name"> {{ item.name }}</span>
              </div>
              <div class="row">
                <span class="group">{{item.chineseName}}</span>
              </div>
            </div>
            <div class="right">
              <img src="../../assets/right.png" style="width: 16px; height: 16px;" alt="">
            </div>
          </div>
          <div class="line"></div>
          <div class="bottom">
            <div class="row">
              <van-button @click="cancelBMMatchTeam(item)" v-if="(item.role === 1 || item.role === 2) && (item.auditStatus === 0 || item.auditStatus === 1)" round type="default" style="width: 70px; height: 30px; margin-right: 12px" plain>
                <span style="font-size: 12px">取 消</span>
              </van-button>
              <van-button @click="cancelBMMatchTeam(item)" v-if="(item.role === 1 || item.role === 2) && item.auditStatus === -1" round type="danger" style="width: 70px; height: 30px; margin-right: 12px" plain>
                <span style="font-size: 12px">删 除</span>
              </van-button>
              <van-button @click="adjustTeamInfo(item)" v-if="(item.role === 1 || item.role === 2) && (item.auditStatus === 0 || item.auditStatus === 1 || item.auditStatus === 2)" round type="info" style="width: 70px; height: 28px; margin-right: 12px">
                <span style="font-size: 12px">调 整</span>
              </van-button>
<!--              <van-button  round type="info" style="width: 70px; height: 28px; margin-right: 12px">-->
<!--                <span style="font-size: 12px">详 情</span>-->
<!--              </van-button>-->
              <van-button v-if="item.role === 0 || item.role === 2" @click="goEntryCertificate(item)" round type="info" style="width: 100px; height: 28px;">
                <span style="font-size: 12px">参赛证</span>
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <van-empty v-else description="暂无报名" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {Image as VanImage, Button, Dialog, Toast, Empty} from 'vant'
Vue.use(VanImage).use(Button).use(Empty)
import {
  cancelBMMatchTeam,
  getBMUnionMatch, getMatchTeamListByUser,
  getMerchantMatchTeamListByUser
} from "@/api/match";
import {DateUtil, QNImageUtil} from "@/utils";
import {getPassport} from "@/libs/passport";
export default {
  data() {
    return {
      merchantId: '',
      list: [],
      isLoading: false,
      loading: false,
      finished: true,
      pageSize: 10,
      pageNum: 1
    }
  },
  mounted() {
    this.merchantId = this.$route.params.merchantId
    getPassport().then(res => {
      if (res) {
        this.getMerchantMatchTeamListByUser()
      }
    })
  },
  methods: {
    goMatchDetail(item) {
      this.$router.push(`/match/home?matchId=${item.matchId}`)
    },
    goEntryCertificate(item) {
      this.$router.push(`/entry-page/entry-certificate/${item.matchId}`)
    },
    imgView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getFormatDate(date, type) {
      if (!type) type = '{y}-{m}-{d}'
      return DateUtil.parseDateTime(date, type)
    },
    getBMUnionMatch() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMUnionMatch(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match || {}
        }
      })
    },
    getMatchTeamListByUser() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getMatchTeamListByUser(params).then(res => {
        if (res) {
          const data = res.data
          this.teams = data.list
        }
      })
    },
    cancelBMMatchTeam(item) {
      Dialog.confirm({
        title: '是否取消报名',
        message: '取消后，数据将丢失',
      }).then(() => {
        const params = {
          matchId: item.matchId,
          teamId: item.teamId
        }
        cancelBMMatchTeam(params).then(res => {
          if (res) {
            Toast.success('取消成功')
            this.getMatchTeamListByUser()
          }
        })
      })
    },
    adjustTeamInfo(item) {
      if (item.unitType === 0) {
        this.$router.push({path: '/entry-page/entry-info', query: {unionMatchId: this.unionMatchId, matchId: item.matchId, teamId: item.teamId}})
      } else if (item.unitType === 1) {
        this.$router.push({path: '/entry-page/entry-info-person', query: {unionMatchId: this.unionMatchId, matchId: item.matchId, teamId: item.teamId}})
      } else if (item.unitType === 2) {
        this.$router.push({path: '/entry-page/entry-info-more', query: {unionMatchId: this.unionMatchId, matchId: item.matchId, teamId: item.teamId}})
      }
    },
    getMerchantMatchTeamListByUser() {
      const params = {
        merchantId: this.merchantId,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      getMerchantMatchTeamListByUser(params).then(res => {
        if (res) {
          const { data } = res
          this.list = this.list.concat(data.list)
          if (this.pageSize > data.list.length) {
            this.finished = true
          } else {
            this.finished = false
            this.pageNum++
          }
          this.isLoading = false
        }
      })
    },
    goMatch(state, id) {
      if (state === '可报名') {
        this.$router.push('/entry-page?unionMatchId=' + id)
      } else {
        this.$router.push('/union-match?unionMatchId=' + id)
      }
    },
    onRefresh() {
      this.pageSize = 10
      this.pageNum = 1
      this.list = []
      this.getMerchantMatchTeamListByUser()
    }
  }
}
</script>

<style scoped lang="scss">
.entry-list {
  .match {
    background-color: #fff;
    border-radius: 4px 4px 8px 8px;
    margin-bottom: 12px;
    .info {
      margin: 0 16px;
      padding: 16px 0 12px 0;
      display: flex;
      flex-flow: row;
      .left {
        text-align: center;
        width: 44px;
        .care {
          width: 44px;
          height: 20px;
          border-radius: 2px;
          background-color: #BEF002;
          color: #191919;
          font-size: 12px;
          line-height: 20px;
          text-align: center;
          margin-top: 12px;
        }
      }
      .right {
        width: calc(100% - 36px);
        padding-left: 12px;
        box-sizing: border-box;
        .title {
          height: 48px;
          font-size: 18px;
          font-weight: 500;
          color: #191919;
          overflow:hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        .address {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #999999;
        }
        .size-count {
          margin-top: 4px;
          display: flex;
          flex-flow: row;
          font-size: 12px;
          color: #474747;
          .count {
            margin-left: 12px;
          }
        }
      }
    }
  }
  .teams {
    padding: 16px 16px 20px 16px;
    .team {
      padding: 16px 12px 12px 12px;
      margin-bottom: 12px;
      background-color: #F8F8F8;
      border-radius: 4px;
      .top {
        display: flex;
        justify-content: space-between;
        .left {
          .status-team-name {
            overflow:hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            .status {
              color: #FFFFFF;
              border-radius: 2px;
              display: inline-block;
              height: 20px;
              width: 48px;
              line-height: 20px;
              font-size: 12px;
              text-align: center;
            }
            ._0 {
              background-color: #0ABB58;
            }
            ._1 {
              background-color: #333333;
            }
            ._2 {
              background-color: #0ABB58;
            }
            ._3 {
              background-color: #F95252;
            }
            .team-name {
              font-size: 16px;
              height: 20px;
              color: #333333;
            }
          }
          .row {
            display: flex;
            padding: 5px 0;
            .group {
              font-size: 14px;
              color: #333333;
            }
          }
        }
        .right {
          width: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .line {
        margin: 4px 0 12px 0;
        height: 1px;
        background-color: #F3F3F3;
      }
      .bottom {
        .row {
          display: flex;
          justify-content: right;
        }
      }
    }
  }
}
</style>
